import { useTranslation } from 'react-i18next'
import styles from './InvitedFriends.module.scss'
import FriendStatus from 'pages/app/referral/components/friend-status/FriendStatus'
import { useStoreSelector } from 'hooks/store.ts'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton'
import { useGetContactReferralsQuery } from 'store/queries/bolt-api/contacts'

const Friends = () => {
  // REDUX
  const { contact } = useStoreSelector((store) => store.contact)

  // Redux queries
  const { data: referrals, isLoading, isError } = useGetContactReferralsQuery(contact?.sfId || '', { skip: !contact })

  // constants
  const friendsAmount = referrals?.filter((referral) => !referral.pending)?.length ?? 0
  const singularOrPlural = friendsAmount === 1 ? 'singular' : 'plural'

  // i18n
  const { t } = useTranslation('referral')

  return (
    <article className={styles['card-group']}>
      <section className={styles['friends-card']}>
        {isLoading ? (
          <LoadingSkeleton>
            <LoadingSkeleton.Paragraph lines={1} />
            <div className={styles['friends-content']}>
              {Array.from({ length: 3 }).map((_, index) => (
                <div key={index} className={styles['loading-status']}>
                  <LoadingSkeleton.Rectangle width="40px" height="40px" />
                  <LoadingSkeleton.Rectangle width="100%" height="40px" />
                </div>
              ))}
            </div>
          </LoadingSkeleton>
        ) : isError || !friendsAmount ? (
          <p>{t(($) => $.referrals.noFriends.paragraph)}</p>
        ) : (
          <>
            <p>
              {t(($) => $.referrals.hasFriends[singularOrPlural].paragraph, {
                friendsAmount: friendsAmount
              })}
            </p>
            <ul className={styles['friends-content']}>
              {/* Pending referrals first */}
              {[...(referrals ?? [])]
                .sort((a, b) => (a.pending === b.pending ? 0 : a.pending ? -1 : 1))
                .map((referral, index) => (
                  <FriendStatus key={index} referral={referral} />
                ))}
            </ul>
          </>
        )}
      </section>
    </article>
  )
}

export default Friends
